import { render, staticRenderFns } from "./SdoLoader.vue?vue&type=template&id=5e4cb16a&scoped=true&lang=pug&"
import script from "./SdoLoader.vue?vue&type=script&lang=js&"
export * from "./SdoLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4cb16a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
